"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlSearchProvider = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_1 = require("react-router");
class UrlSearchProvider extends react_1.default.Component {
    render() {
        return (react_1.default.createElement(react_router_1.Route, null, ({ history }) => (react_1.default.createElement(UrlSearchProviderInternal, { history: history }, this.props.children))));
    }
}
exports.UrlSearchProvider = UrlSearchProvider;
class UrlSearchProviderInternal extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.update = (newValue) => {
            if (newValue === this.props.history.location.search) {
                return;
            }
            const history = this.props.history;
            history.replace({
                pathname: history.location.pathname,
                search: newValue,
            });
        };
    }
    render() {
        return (this.props.children({
            value: this.props.history.location.search,
            update: this.update,
        }));
    }
}
//# sourceMappingURL=UrlSearchProvider.js.map